import {BASE_URL} from "app/config/env";

const prefix = `${BASE_URL}/panel`;

export const integrations = {
  'app.integrations': `${prefix}/integrations`,
}
